import { ENotConfidentialRequestFormField } from '../../types/requestFormSchema';

const NOT_CONFIDENTIAL_FIELDS = Object.values(ENotConfidentialRequestFormField);

/* oxlint-disable typescript/no-explicit-any */
export function isSensitiveFormFields(field: any): boolean {
  return !NOT_CONFIDENTIAL_FIELDS.includes(field);
}
